import React from 'react';
import PropTypes from 'prop-types';
import {
  Platform,
  KeyboardAvoidingView,
  View,
} from 'react-native';
import {
  Button, Input, Text,
} from 'react-native-elements';
import { Formik } from 'formik';
import { object as yupObject } from 'yup';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';

import Breadcrumb from '../../../../vendor/react-native-breadcrumb';
import { translate } from '../../../locales/i18n';
import styles from '../../../styles';
import stylesPublisher from '../../../styles/create';
import {
  appPriceValidation,
} from '../../../modules/validation/App';
import App from '../../../modules/data/App';

const validationSchema = yupObject().shape({
  buyPrice: appPriceValidation,
  rentPrice: appPriceValidation,
});

class PublisherAppFormFinancial extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleCancel = this.handleCancel.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleNext = this.handleNext.bind(this);

    // const { app } = this.props;

    // const { importedFrom } = app.data;
    this.state = {
      // imported: !!importedFrom,
    };
  }

  handleCancel() {
    const { onCancel } = this.props;

    onCancel();
  }

  handleBack(values) {
    const { onSave, onPageSwitch } = this.props;

    onSave(values);
    onPageSwitch(4);
  }

  async handleNext(values, formikBag) {
    const {
      onSave,
      onPageSwitch,
      getAnalyticsService,
    } = this.props;
    const {
      type,
    } = this.state;

    formikBag.setSubmitting(true);
    const err = await onSave(values);
    if (err !== null) {
      getAnalyticsService().report.event('page4SaveError', 'create');
      formikBag.setStatus(err);
    } else {
      getAnalyticsService().report.event(`page4SaveSuccess${type}`, 'create');
    }
    formikBag.setSubmitting(false);

    if (err === null) {
      onPageSwitch(6);
    }
  }

  renderForm = ({
    isValid,
    values,
    handleSubmit,
    setFieldValue,
    touched,
    errors,
    setFieldTouched,
    isSubmitting,
    status,
  }) => {
    const { onPageSwitch, direction } = this.props;
    // const { imported } = this.state;

    // const readonly = imported;
    const readonly = false;

    return (
      <>
        <Breadcrumb
          entities={[
            translate('create_app_app'),
            translate('create_app_guide'),
            translate('create_app_endpoints'),
            translate('create_app_payment'),
            translate('create_app_links'),
            translate('create_app_review'),
          ]}
          isTouchable
          flowDepth={4}
          onCrumbPress={(index) => onPageSwitch(index + 1)}
          borderRadius={3}
          firstCrumbStyle={stylesPublisher.publisherAppEdit.firstCrumbStyle}
          crumbsContainerStyle={direction === 'column' ? stylesPublisher.publisherAppEdit.crumbsContainerStyle : stylesPublisher.publisherAppEdit.crumbsContainerStyleLandscape}
        />
        {/* Page 4: Financials */}
        <KeyboardAvoidingView
          style={[
            styles.view.form,
            {
              backgroundColor: 'white',
              width: '100%',
              padding: 0,
              margin: 0,
              alignItems: 'center',
              justifyContent: 'space-evenly',
            },
          ]}
          behavior="padding"
        >
          <KeyboardAwareScrollView
            style={{
              flex: 1,
              width: '100%',
              maxWidth: 600,
              alignSelf: 'center',
              margin: 0,
            }}
            contentContainerStyle={{
              width: '100%',
              padding: 0,
              alignItems: 'center',
              justifyContent: 'space-evenly',
              paddingBottom: 20,
            }}
            enableAutomaticScroll={false}
          >
            {status !== undefined && (
              <Text
                style={{
                  color: 'red',
                }}
              >
                {status}
              </Text>
            )}

            {/* {imported ? (
              <Text
                style={{
                  width: '80%',
                  marginVertical: 10,
                  textAlign: 'center',
                  color: 'red',
                }}
              >
                {translate('app_links_imported')}
              </Text>
            ) : ( */}
            <Text
              style={{
                width: '80%',
                marginVertical: 10,
                textAlign: 'center',
                fontFamily: styles.primaryFont400,
                fontWeight: '400',
                fontSize: 14,
              }}
            >
              {translate('create_app_links_comment')}
            </Text>
            {/* )} */}

            <Input
              containerStyle={styles.form.inputContainer}
              labelStyle={[
                styles.form.inputLabel,
                { color: !readonly ? 'black' : 'grey' },
              ]}
              inputStyle={styles.form.inputInput}
              inputContainerStyle={touched.web && errors.web ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
              disabled={readonly}
              editable={!readonly}
              label={translate('create_app_link_web')}
              keyboardType={Platform.OS === 'ios' ? 'url' : 'default'}
              value={values.web}
              placeholder="https://..."
              autoCapitalize="none"
              onChangeText={(value) => setFieldValue('web', value)}
              onBlur={() => setFieldTouched('web')}
              errorMessage={touched.web && errors.web ? errors.web : ''}
            // errorMessage={touched.web && errors.web ? errors.web : translate('create_app_link_web_comment')}
            // errorStyle={touched.web && errors.web ? {} : { color: 'black' }}
            />
            <Input
              containerStyle={styles.form.inputContainer}
              labelStyle={[
                styles.form.inputLabel,
                { color: !readonly ? 'black' : 'grey' },
              ]}
              inputStyle={styles.form.inputInput}
              inputContainerStyle={touched.youtube && errors.youtube ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
              disabled={readonly}
              editable={!readonly}
              label={translate('create_app_link_youtube')}
              keyboardType={Platform.OS === 'ios' ? 'url' : 'default'}
              value={values.youtube}
              placeholder="https://youtube.com/..."
              autoCapitalize="none"
              onChangeText={(value) => setFieldValue('youtube', value)}
              onBlur={() => setFieldTouched('youtube')}
              errorMessage={touched.youtube && errors.youtube ? errors.youtube : ''}
            // errorMessage={touched.youtube && errors.youtube ? errors.youtube : translate('create_app_link_youtube_comment')}
            // errorStyle={touched.youtube && errors.youtube ? {} : { color: 'black' }}
            />
            <Input
              containerStyle={styles.form.inputContainer}
              labelStyle={[
                styles.form.inputLabel,
                { color: !readonly ? 'black' : 'grey' },
              ]}
              inputStyle={styles.form.inputInput}
              inputContainerStyle={touched.facebook && errors.facebook ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
              disabled={readonly}
              editable={!readonly}
              label={translate('create_app_link_facebook')}
              keyboardType={Platform.OS === 'ios' ? 'url' : 'default'}
              value={values.facebook}
              placeholder="https://facebook.com/..."
              autoCapitalize="none"
              onChangeText={(value) => setFieldValue('facebook', value)}
              onBlur={() => setFieldTouched('facebook')}
              errorMessage={touched.facebook && errors.facebook ? errors.facebook : ''}
            // errorMessage={touched.facebook && errors.facebook ? errors.facebook : translate('create_app_link_facebook_comment')}
            // errorStyle={touched.facebook && errors.facebook ? {} : { color: 'black' }}
            />
            <Input
              containerStyle={styles.form.inputContainer}
              labelStyle={[
                styles.form.inputLabel,
                { color: !readonly ? 'black' : 'grey' },
              ]}
              inputStyle={styles.form.inputInput}
              inputContainerStyle={touched.instagram && errors.instagram ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
              disabled={readonly}
              editable={!readonly}
              label={translate('create_app_link_instagram')}
              keyboardType={Platform.OS === 'ios' ? 'url' : 'default'}
              value={values.instagram}
              placeholder="https://instagram.com/..."
              autoCapitalize="none"
              onChangeText={(value) => setFieldValue('instagram', value)}
              onBlur={() => setFieldTouched('instagram')}
              errorMessage={touched.instagram && errors.instagram ? errors.instagram : ''}
            // errorMessage={touched.instagram && errors.instagram ? errors.instagram : translate('create_app_link_instagram_comment')}
            // errorStyle={touched.instagram && errors.instagram ? {} : { color: 'black' }}
            />
            <Input
              containerStyle={styles.form.inputContainer}
              labelStyle={[
                styles.form.inputLabel,
                { color: !readonly ? 'black' : 'grey' },
              ]}
              inputStyle={styles.form.inputInput}
              inputContainerStyle={touched.twitter && errors.twitter ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
              disabled={readonly}
              editable={!readonly}
              label={translate('create_app_link_twitter')}
              keyboardType={Platform.OS === 'ios' ? 'url' : 'default'}
              value={values.twitter}
              placeholder="https://twitter.com/..."
              autoCapitalize="none"
              onChangeText={(value) => setFieldValue('twitter', value)}
              onBlur={() => setFieldTouched('twitter')}
              errorMessage={touched.twitter && errors.twitter ? errors.twitter : ''}
            // errorMessage={touched.twitter && errors.twitter ? errors.twitter : translate('create_app_link_twitter_comment')}
            // errorStyle={touched.twitter && errors.twitter ? {} : { color: 'black' }}
            />
          </KeyboardAwareScrollView>
        </KeyboardAvoidingView>
        <View style={styles.form.containerButtons}>
          <Button
            title={translate('button_cancel')}
            containerStyle={styles.button.secondaryContainer}
            buttonStyle={styles.button.secondary}
            disabledStyle={styles.button.secondaryDisabled}
            titleStyle={styles.button.secondaryTitle}
            disabledTitleStyle={styles.button.secondaryTitleDisabled}
            onPress={this.handleCancel}
          />
          <Button
            title={translate('button_prev')}
            containerStyle={styles.button.primaryContainer}
            buttonStyle={styles.button.primary}
            disabledStyle={styles.button.primaryDisabled}
            titleStyle={styles.button.primaryTitle}
            disabledTitleStyle={styles.button.primaryTitleDisabled}
            onPress={() => this.handleBack(values)}
            disabled={!isValid || isSubmitting}
            loading={isSubmitting}
            loadingProps={{ size: 'small', color: 'white' }}
          />
          <Button
            title={translate('button_next')}
            containerStyle={styles.button.primaryContainer}
            buttonStyle={styles.button.primary}
            disabledStyle={styles.button.primaryDisabled}
            titleStyle={styles.button.primaryTitle}
            disabledTitleStyle={styles.button.primaryTitleDisabled}
            onPress={handleSubmit}
            disabled={!isValid || isSubmitting}
            loading={isSubmitting}
            loadingProps={{ size: 'small', color: 'white' }}
          />
        </View>
      </>
    );
  };

  render() {
    const { app } = this.props;

    const initialValues = {
      web: app.data.linkWeb || '',
      youtube: app.data.linkYoutube || '',
      facebook: app.data.linkFacebook || '',
      instagram: app.data.linkInstagram || '',
      twitter: app.data.linkTwitter || '',
    };

    return (
      <Formik
        validateOnMount
        enableReinitialize
        initialValues={initialValues}
        onSubmit={(values, formikBag) => this.handleNext(values, formikBag)}
        validationSchema={validationSchema}
      >
        {this.renderForm}
      </Formik>
    );
  }
}

PublisherAppFormFinancial.defaultProps = {
};

PublisherAppFormFinancial.propTypes = {
  app: PropTypes.instanceOf(App).isRequired,
  onCancel: PropTypes.func.isRequired,
  onPageSwitch: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  getAnalyticsService: PropTypes.func.isRequired,
  direction: PropTypes.string.isRequired,
};

export default PublisherAppFormFinancial;
